/**
 * @generated SignedSource<<86ae5df0b10235093eb0be42d7fb9c16>>
 * @relayHash 895e70ff1a52eb19ffe1cbb7ab6a9887
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 37a01fce5b884472c20b01cf10fd1e02df3143a8366569e63430335c79e61681

import type { ConcreteRequest } from 'relay-runtime';
export type PageRovoActivationQuery$variables = {
  cloudId: string;
};
export type PageRovoActivationQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly activationIdByProduct: {
      readonly active: string | null;
    } | null;
  } | null> | null;
};
export type PageRovoActivationQuery = {
  response: PageRovoActivationQuery$data;
  variables: PageRovoActivationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "items": [
          {
            "kind": "Variable",
            "name": "cloudIds.0",
            "variableName": "cloudId"
          }
        ],
        "kind": "ListValue",
        "name": "cloudIds"
      }
    ],
    "concreteType": "TenantContext",
    "kind": "LinkedField",
    "name": "tenantContexts",
    "plural": true,
    "selections": [
      {
        "args": [
          {
            "kind": "Literal",
            "name": "product",
            "value": "rovo"
          }
        ],
        "concreteType": "TenantContextActivationId",
        "kind": "LinkedField",
        "name": "activationIdByProduct",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "active"
          }
        ],
        "storageKey": "activationIdByProduct(product:\"rovo\")"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PageRovoActivationQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PageRovoActivationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "895e70ff1a52eb19ffe1cbb7ab6a9887",
    "id": "37a01fce5b884472c20b01cf10fd1e02df3143a8366569e63430335c79e61681",
    "metadata": {},
    "name": "PageRovoActivationQuery",
    "operationKind": "query",
    "text": "query PageRovoActivationQuery($cloudId:ID!){tenantContexts(cloudIds:[$cloudId]){activationIdByProduct(product:\"rovo\"){active}}}"
  }
};
})();

(node as any).hash = "40874e00231000702f552cb16eaa9715";

export default node;
